import { datadogRum, type RumEvent } from '@datadog/browser-rum';
import type { DatadogSettings } from '../../common/interfaces/frontendSettings';

let isConfigured = false;

function isIgnorableDatadogRumEvent(event: RumEvent) {
    const isAbortError = event.type === 'error' && event.error.type === 'AbortError';

    return isAbortError;
}

export function configureAndStartDatadogRum({
    allowedTracingUrls,
    applicationId,
    clientToken,
    env,
    isEnabled,
    trackLongTasks,
    trackResources,
    trackUserInteractions,
    version,
}: DatadogSettings) {
    if (isEnabled === false || isConfigured) {
        return;
    }

    datadogRum.init({
        allowedTracingUrls: allowedTracingUrls.split(','),
        applicationId,
        beforeSend: (event, _context) => {
            return !isIgnorableDatadogRumEvent(event);
        },
        clientToken,
        defaultPrivacyLevel: 'mask',
        enablePrivacyForActionName: true,
        env,
        service: 'mijnksyos',
        sessionPersistence: 'local-storage',
        sessionReplaySampleRate: 100,
        sessionSampleRate: 100,
        site: 'datadoghq.eu',
        trackLongTasks,
        trackResources,
        trackUserInteractions,
        useSecureSessionCookie: true,
        version,
    });

    datadogRum.startSessionReplayRecording();

    isConfigured = true;
}

export function getDatadogRumSessionId(): string | undefined {
    return datadogRum.getInternalContext()?.session_id;
}
